import { INotification } from './notification.model';

export class NotificationBasique implements INotification {
  constructor(
    public title: string | undefined,
    public body: string | undefined
  ) {}
}
